import React, {memo, useEffect, useState} from "react"
import VideoTitleComponent from "../../Atoms/VideoTitle/VideoTitle.component";
import "./ProductVideoSection.scss"
import {AppContext} from "../../../../context/AppContext";
import {observer} from "mobx-react";
import {apiUrl} from "../../../../constants/constants";
import HomeTopSection from "../../Atoms/HomeTopSection/HomeTopSection";
import { SetScreenSize } from "../../../../utils/utils";

interface IProps {
    device: "MB" | "TB" | "DT"
}

const ProductVideoSectionComponent: React.FC<IProps> = observer(({device}) => {
    const [data, setData] = useState()
    const {bannerDataStore} =
        React.useContext(AppContext);
    const {isTopBannerClose} = bannerDataStore

    const isShowTopBanner = (flag = false) => {
        const topBannerId = document.getElementById('topBanner')
        if (topBannerId) {
            const topBannerHeight = topBannerId.getBoundingClientRect().height;
            const productVideoElement = document.getElementById('productVideoSection')
            if (productVideoElement && (topBannerHeight > 0 || flag)) {
                const documentHeight = document.body.getBoundingClientRect().height;
                productVideoElement.style.height = `${documentHeight - topBannerHeight}px`;
                productVideoElement.style.maxHeight = `${documentHeight - topBannerHeight}px`;

            }
        }
    }

    const getSectionData = async () => {
        await fetch(`${apiUrl}/api/home-section`).then(res => res.json().then(data => setData(data)))
    }

    useEffect(() => {
        isShowTopBanner()
    }, [device])

    useEffect(() => {
        getSectionData()
        SetScreenSize()
        window.addEventListener('resize', function () {
            SetScreenSize()
        });
        return () => {
            window.removeEventListener('resize', function () {
                SetScreenSize()
            });
        }
    }, [])

    useEffect(() => {
        if (isTopBannerClose) {
            isShowTopBanner(true)
        }
    }, [isTopBannerClose])

    return (
        <div className="product-video-section-wrapper" id={'productVideoSection'}>
            <HomeTopSection data={data} device={device}/>
        </div>
    )
})

export default ProductVideoSectionComponent
